<template>
  <div class="scroll-container">
    <a-button
      class="top_btn"
      type="primary"
      @click="
        () => {
          openAddModal();
        }
      "
    >
      添加分类
    </a-button>
    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      rowKey="id"
      :pagination="pagination"
    >
      <span slot="type" slot-scope="text, record">
        {{ record.type == 1 ? "IconFont图标" : "彩色图标" }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a
          @click="
            (record) => {
              visiblebj = true;
              editId = text.id;
              getEditData();
            }
          "
          >编辑<a-divider type="vertical"
        /></a>
        <a-popconfirm
          title="此操作将永久删除, 是否继续?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="confirm(record)"
          @cancel="() => {}"
        >
          <a>删除</a>
        </a-popconfirm>
      </span>
    </a-table>
    <a-drawer
      :title="drawerTitle"
      placement="right"
      :visible="visiblebj"
      @close="onClose"
      :width="600"
      :destroyOnClose="true"
      :body-style="{ paddingBottom: '80px' }"
    >
      <a-form-model
        ref="ruleform"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item
          ref="name"
          label="所属类型"
          prop="type"
          :help="formErr.type"
          :validateStatus="!formErr.type || formErr.type == '' ? '' : 'error'"
        >
          <a-select v-model="form.type">
            <a-select-option
              :key="item.value"
              :value="item.value"
              v-for="item in typeList"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item
          ref="name"
          label="分类名称"
          prop="name"
          :help="formErr.name"
          :validateStatus="!formErr.name || formErr.name == '' ? '' : 'error'"
        >
          <a-input
            v-model="form.name"
            @change="
              (e) => {
                formErr.name = '';
              }
            "
            :maxLength="20"
            @blur="
              (e) => {
                form.name = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-btn">
        <a-button
          type="primary"
          @click="onSubmit"
          :style="{ marginRight: '8px' }"
        >
          确定
        </a-button>
        <a-button @click="onClose">
          取消
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import {
  submitForm,
  drawerConfig,
  validator,
  changStatus,
  removeById,
  orderList
} from "../../../../utils/utils";
import API from "../api";
const columns = [
  {
    title: "分类名称",
    dataIndex: "name",
    ellipsis: true,
    key: "name",
    width: "25%"
  },
  {
    title: "所属类型",
    dataIndex: "type",
    ellipsis: true,
    key: "type",
    width: "25%",
    scopedSlots: { customRender: "type" }
  },
  {
    title: "添加时间",
    dataIndex: "create_time",
    ellipsis: true,
    key: "create_time",
    width: "25%"
  },
  {
    title: "操作",
    key: "action",
    width: "25%",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: "cateList",
  data() {
    return {
      drawerConfig,
      pageNum: "",
      visiblebj: false,
      titleForm: "",
      editId: null,
      fieldId: null,
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true
      },
      data: [],
      columns,
      loading: true,
      sortLists: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      formErr: { name: "", type: "" },
      form: { name: "", type: "" },
      typeList: [],
      rules: {
        type: [
          { required: true, message: "请选择所属类型" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.type);
            },
            trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "请填写分类名称" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.name);
            },
            trigger: "blur"
          }
        ]
      },
      drawerTitle: "添加图标分类"
    };
  },

  components: {},

  mounted() {
    this.getList();
    this.getAdd();
  },
  methods: {
    onClose() {
      this.visiblebj = false;
      this.formErr.name = "";
      this.form.name = "";
      this.form = { name: "", type: "" };
    },
    getList(page) {
      this.pageNum = page;
      API.cate.GET_LIST(page || 1).then((res) => {
        this.pagination.total = res.data.data.list.total;
        this.pagination.pageSize = res.data.data.list.per_page;
        this.pagination.current = res.data.data.list.current_page;
        this.data = res.data.data.list.data;
        this.loading = false;
      });
    },
    getAdd() {
      API.cate.ADD().then((res) => {
        this.typeList = res.data.data.type;
      });
    },
    // 添加
    openAddModal() {
      this.form = {
        name: "",
        type: 1
      };
      this.visiblebj = true;
      this.drawerTitle = "添加图标分类";
    },
    // 编辑
    getEditData() {
      this.drawerTitle = "编辑图标分类";
      API.cate.EDIT(this.editId).then((res) => {
        this.form = res.data.data.info;
      });
    },
    onSubmit() {
      if (this.form["id"]) {
        this.editPost();
      } else {
        this.addPost();
      }
    },
    // 编辑提交
    editPost() {
      let _this = this;
      this.$refs.ruleform.validate((valid) => {
        if (valid) {
          submitForm(API.cate.EDIT_POST, _this.form).then((res) => {
            if (res == true) {
              this.onClose();
              this.getList(this.pageNum);
            } else {
              res.map((item, index) => {
                this.formErr[item.field] = item.msg;
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addPost() {
      let _this = this;
      this.$refs.ruleform.validate((valid) => {
        if (valid) {
          submitForm(API.cate.ADD_POST, _this.form).then((res) => {
            if (res == true) {
              this.onClose();
              this.getList();
            } else {
              res.map((item, index) => {
                this.formErr[item.field] = item.msg;
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    confirm(row) {
      removeById(API.cate.DELE, [row.id]).then((res) => {
        if (res == true) {
          this.getList();
        }
      });
    }
  }
};
</script>

<style scoped>
.btntable {
  margin-right: 10px;
}
.inputs {
  display: inline-block;
  width: 70px;
}
.scroll-container {
  height: calc(100vh - 250px);
  overflow: auto;
}
.scroll-container::-webkit-scrollbar {
  width: 8px;
  background: white;
}
.scroll-container::-webkit-scrollbar-corner,
.scroll-container::-webkit-scrollbar-thumb,
.scroll-container::-webkit-scrollbar-track {
  border-radius: 4px;
}
.scroll-container::-webkit-scrollbar-corner,
.scroll-container::-webkit-scrollbar-track {
  background-color: #ddd;
  box-shadow: inset 0 0 1px #ddd;
}
.scroll-container::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}
</style>
